var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { CentralProviderContextProvider } from '../centralProviderContext/CentralProviderContext';
import CentralProviderChildren from './CentralProviderChildren';
import { AuthContextProvider } from '../authContext/AuthContext';
import { MaestroQueryClientProvider } from '../providers/MaestroQueryClientProvider';
window.missingTranslations = new Map();
var DEFAULT_QUERY_CLIENT_CONFIG = {
    defaultOptions: {
        queries: {
            staleTime: 10000,
            refetchOnWindowFocus: false,
            notifyOnChangeProps: ['data', 'error'],
        },
    },
};
var DEFAULT_PREPARE_QUERY_CLIENT_CONFIG = function (baseConfig) {
    return baseConfig;
};
var CentralProvider = function (allProps) {
    var _a = allProps.prepareQueryClientConfig, prepareQueryClientConfig = _a === void 0 ? DEFAULT_PREPARE_QUERY_CLIENT_CONFIG : _a, queryClientBaseUrl = allProps.queryClientBaseUrl, themes = allProps.themes, props = __rest(allProps, ["prepareQueryClientConfig", "queryClientBaseUrl", "themes"]);
    window.useCentralProviderDebugger = props.useCentralProviderDebugger || false;
    /**
     * It is intentional that this does not allow for on-the-fly query client config changes at this time
     * as it is more friendly to referentially unstable callbacks provided as `prepareQueryClientConfig` (e.g.
     * anonymous callbacks provided inline to the component's prop)
     */
    var queryClientConfig = useMemo(function () { return prepareQueryClientConfig(DEFAULT_QUERY_CLIENT_CONFIG); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(CentralProviderContextProvider, { themes: themes },
            React.createElement(AuthContextProvider, null,
                React.createElement(MaestroQueryClientProvider, { queryClientConfig: queryClientConfig, baseURL: queryClientBaseUrl },
                    React.createElement(CentralProviderChildren, __assign({}, props))))),
        React.createElement("div", { id: "central-provider-portal" })));
};
export default CentralProvider;
//# sourceMappingURL=CentralProvider.js.map